export default {
  Revenue_SignUpPage_Clicked_SignUpButton: 'Revenue_SignUpPage_Clicked_SignUpButton',
  Revenue_SignUpPage_Clicked_SignInButton: 'Revenue_SignUpPage_Clicked_SignInButton',
  Revenue_SignUpPage_Clicked_MarketingOptOutCheckbox:
    'Revenue_SignUpPage_Clicked_MarketingOptOutCheckbox',
  Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox:
    'Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox'
}
